var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('div',{staticClass:"flex flex-row max-h-screen bg-white border rounded shadow overflow-x-none border-blue-light_ relative",staticStyle:{"height":"75vh"}},[_c('div',{ref:'viewer_' + _vm.nameViewerRef,staticClass:"flex flex-col w-full h-full",staticStyle:{"height":"75vh"},attrs:{"id":'viewer_' + _vm.nameViewerRef}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }